<script>
import required from "vuelidate/lib/validators/required";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import cloneDeep from "lodash/cloneDeep";
import Disposal from "@/components/modals/property-disposal.vue";

export default {
  name: "POModal",
  components: {
    DatePicker,
    MaskedInput,
    Disposal
  },
  data() {
    return {
      disposal: {
        id: "",
        description: "",
        venue: "",
        disposalMethod: "",
        destination: "",
        orNumber: "",
        orDate: "",
        amount: "",
        inspectedBy: "",
        witness: "",
        notes: "",
        campusId: this.$store.state.data.selectedCampus.id
      },
      disposalItems: [],
      isCreate: false,
      loading: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      submitted: false
    };
  },
  validations: {
    disposal: {
      description: { required }
    }
  },
  computed: {
    filledItems() {
      let data = this.disposalItems;
      if (this.disposalItems.length > 0) {
        data = data.filter((item) => {
          return (
            item.propertyFinalStatus != "" &&
            item.propertyFinalStatus != null &&
            item.inspectionDate != "" &&
            item.inspectionDate != null &&
            item.accumulatedDepreciation != "" &&
            item.accumulatedDepreciation != null &&
            item.accumulatedImpairmentLosses != "" &&
            item.accumulatedImpairmentLosses != null &&
            item.carryingAmount != "" &&
            item.carryingAmount != null &&
            item.appraisedValue != "" &&
            item.appraisedValue != null
          );
        });
      }
      return data.length;
    }
  },
  methods: {
    setDisposal(items, disposal) {
      this.isCreate = !disposal;
      this.submitted = false;
      this.disposal = {
        id: "",
        description: "",
        venue: "",
        disposalMethod: "",
        destination: "",
        orNumber: "",
        orDate: disposal ? new Date(disposal.orDate) : "",
        amount: disposal ? disposal.amount.toString() : "",
        inspectedBy: "",
        witness: "",
        notes: "",
        campusId: this.$store.state.data.selectedCampus.id
      };
      this.disposalItems = items;
      this.$bvModal.show("create-disposal-modal");
    },
    onChange() {
      this.disposal = {
        id: "",
        description: "",
        venue: "",
        disposalMethod: "",
        destination: "",
        orNumber: "",
        orDate: "",
        amount: "",
        inspectedBy: "",
        witness: "",
        notes: "",
        campusId: this.$store.state.data.selectedCampus.id
      };
    },
    onSubmit() {
      if (this.isCreate) this.onCreate();
      else this.onUpdateItems();
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let items = cloneDeep(this.disposalItems);
      items.forEach((item) => {
        item.disposalId = this.disposal.id;
      });
      this.$store
        .dispatch("propertydisposal/AddPropertyDisposalItem", items)
        .then((res) => {
          this.submitted = false;
          this.$bvModal.hide("create-disposal-modal");
          this.showToast("Successfully Created", "success");
        })
        .catch((err) => {
          this.showToast("Cannot be created!", "error");
        });
    },
    onUpdateItems() {
      this.submitted = true;
      this.$v.$touch();
      if (this.disposalItems.length != this.filledItems) {
        return;
      }
      this.disposalItems.forEach((item) => {
        item.inspectionDate = this.getDate(item.inspectionDate);
        item.accumulatedDepreciation = this.getExactAmt(
          item.accumulatedDepreciation
        );
        item.accumulatedImpairmentLosses = this.getExactAmt(
          item.accumulatedImpairmentLosses
        );
        item.carryingAmount = this.getExactAmt(item.carryingAmount);
        item.appraisedValue = this.getExactAmt(item.appraisedValue);
      });
      this.$store
        .dispatch("propertydisposal/PostMultiplePropertyDisposalItem", this.disposalItems)
        .then((res) => {
          this.submitted = false;
          this.$emit("postDisposal", this.disposalItems[0].disposalId);
          this.$bvModal.hide("create-disposal-modal");
          this.showToast("Successfully Posted", "success");
        })
        .catch((err) => {
          this.showToast("Cannot be posted!", "error");
        });
    },
    getDisposal() {
      this.$refs.disposal.getData();
      this.$bvModal.show("disposal-modal");
    },
    dropDisposal(data) {
      this.disposal = cloneDeep(data);
      this.disposal.orNumber = this.disposal.orNumber.toString();
      this.disposal.orDate = new Date(this.disposal.orDate);
    }
  }
};
</script>
<template>
  <b-modal id="create-disposal-modal" title="Create Disposal" :size="isCreate ? 'md' : 'xl'" title-class="font-20"
    hide-footer no-close-on-backdrop>
    <form @submit.prevent="onSubmit" class="needs-validation" ref="fcForm">
      <div v-if="isCreate" class="mb-3">
        <div class="mb-3">
          <label for="disposalId">Disposal </label>
          <b-input-group>
            <template #append>
              <b-button @click="getDisposal()" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Search Disposal..." class="form-control" :class="{
              'is-invalid': submitted && $v.disposal.description.$error
            }" v-model="disposal.description" />
          </b-input-group>
          <div v-if="submitted && $v.disposal.description.$error" class="invalid-feedback">
            <span v-if="!$v.disposal.description.required">This value is required.</span>
          </div>
        </div>
      </div>

      <div v-else-if="!isCreate" class="mb-3">
        <div class="row mb-3">
          <div class="col">
            <label for="amount">Amount </label>
            <masked-input id="amount" type="text" v-model="disposal.amount" placeholder="Enter Amount..."
              class="form-control" :class="{
                'is-invalid': submitted && (disposal.amount == null || disposal.amount == '')
              }" autocomplete="off" :mask="currencyMask"></masked-input>
            <div v-if="submitted && (disposal.amount == null || disposal.amount == '')" class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <div class="col">
            <label for="orDate">OR Date</label>
            <date-picker v-model="disposal.orDate" :first-day-of-week="1" lang="en" placeholder="Enter Start Date..."
              :class="{
                'is-invalid': submitted && (disposal.orDate == null || disposal.orDate == '')
              }"></date-picker>
            <div v-if="submitted && (disposal.orDate == null || disposal.orDate == '')" class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <label>Items for Disposal</label>
          <div>
            Completed <b class="text-info">{{ filledItems }}</b> of
            {{ disposalItems.length }}
          </div>
        </div>
        <hr class="mt-0 mb-2" />
        <div style="max-height: 340px; overflow: auto" class="pe-2">
          <div v-for="(item, index) in disposalItems" :key="index">
            <div class="d-flex mb-2 border-bottom" style="width: 100%">
              <div style="width: 25px;">{{ index + 1 }}.</div>
              <div style="width: 100%" class="pe-2">
                <div class="row mb-2">
                  <div class="col">
                    <div>{{ item.name }}</div>
                    <small>{{ item.propertyNumber }}</small>
                  </div>
                </div>
                <div class="row mb-2">
                  <!-- <div class="col">
                    <small>Inspected By</small>
                    <input id="inspectedBy" type="text" v-model="item.inspectedBy" placeholder="Enter Inspected By..."
                      class="form-control mt-1" :class="{
                        'is-invalid':
                          submitted &&
                          (item.inspectedBy == null || item.inspectedBy == '')
                      }" autocomplete="off" />
                  </div> -->
                  <div class="col">
                    <small>Inspection Date</small>
                    <date-picker v-model="item.inspectionDate" :first-day-of-week="1" lang="en"
                      placeholder="Enter Inspection Date..." class="mt-1" :class="{
                        'is-invalid':
                          submitted &&
                          (item.inspectionDate == null ||
                            item.inspectionDate == '')
                      }"></date-picker>
                  </div>
                  <div class="col">
                    <small>Property Final Status</small>
                    <b-form-select class="form-select mt-1" :class="{
                      'is-invalid':
                        submitted &&
                        (item.propertyFinalStatus == null ||
                          item.propertyFinalStatus == '')
                    }" v-model="item.propertyFinalStatus">
                      <b-form-select-option value="" disabled>Select Property Final Status...</b-form-select-option>
                      <b-form-select-option value="Very Good">Very Good (VG) (80-100%)</b-form-select-option>
                      <b-form-select-option value="Good Condition">Good Condition (G) (55-75%)</b-form-select-option>
                      <b-form-select-option value="Fair Condition">Fair Condition (F) (35-50%)</b-form-select-option>
                      <b-form-select-option value="Poor Condition">Poor Condition (P) (15-30%)</b-form-select-option>
                      <b-form-select-option value="Scrap Condition">Scrap Condition (S) (0-10%)</b-form-select-option>
                    </b-form-select>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <small>Accumulated Depreciation</small>
                    <masked-input id="accumulatedDepreciation" type="text" v-model="item.accumulatedDepreciation"
                      placeholder="Enter Depreciation..." class="form-control mt-1" :class="{
                        'is-invalid':
                          submitted &&
                          (item.accumulatedDepreciation == null ||
                            item.accumulatedDepreciation == '')
                      }" autocomplete="off" :mask="currencyMask"></masked-input>
                  </div>
                  <div class="col">
                    <small>Accumulated Impairment Losses</small>
                    <masked-input id="accumulatedImpairmentLosses" type="text"
                      v-model="item.accumulatedImpairmentLosses" placeholder="Enter Impairment Losses..."
                      class="form-control mt-1" :class="{
                        'is-invalid':
                          submitted &&
                          (item.accumulatedImpairmentLosses == null ||
                            item.accumulatedImpairmentLosses == '')
                      }" autocomplete="off" :mask="currencyMask"></masked-input>
                  </div>
                  <div class="col">
                    <small>Carrying Amount</small>
                    <masked-input id="carryingAmount" type="text" v-model="item.carryingAmount"
                      placeholder="Enter Carrying Amount..." class="form-control mt-1" :class="{
                        'is-invalid':
                          submitted &&
                          (item.carryingAmount == null ||
                            item.carryingAmount == '')
                      }" autocomplete="off" :mask="currencyMask"></masked-input>
                  </div>
                  <div class="col">
                    <small>Appraised Value</small>
                    <masked-input id="appraisedValue" type="text" v-model="item.appraisedValue"
                      placeholder="Enter Appraised Value..." class="form-control mt-1" :class="{
                        'is-invalid':
                          submitted &&
                          (item.appraisedValue == null ||
                            item.appraisedValue == '')
                      }" autocomplete="off" :mask="currencyMask"></masked-input>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <small>Remarks</small>
                    <textarea id="remarks" rows="2" v-model="item.remarks" placeholder="Enter Remarks..."
                      class="form-control mt-1" autocomplete="off"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-2" />
      </div>
      <div class="d-flex flex-row-reverse">
        <button type="submit" class="btn btn-primary">
          {{ isCreate ? "Create" : "Post" }}
        </button>
      </div>
    </form>
    <Disposal ref="disposal" @dropData="dropDisposal($event)"></Disposal>
  </b-modal>
</template>
